import API from './api';
import moment from 'moment';
import 'react-dates/initialize';
import React, {Component} from 'react';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import {ToggleButton, InlineExpandable} from './form';
import {encodeQueryData, decodeQueryData} from './util';

const FILTER_BREAKPOINT = 560;

function coerceArray(d) {
  d = d || [];
  return Array.isArray(d) ? d : [d];
}

class Dropdown extends Component {
  static defaultProps = {
    numVisible: 3,
    noLimit: false,
    className: '',
    numSelected: 0
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  render() {
    let numSelected = this.props.numSelected;
    return (
      <div className="relative">
        <div
          className={`button ${this.props.open || numSelected > 0 ? 'inverted' : ''}`}
          onClick={this.props.onClick}>
          {this.props.text}{ numSelected > 0 && ` (${numSelected})`}
        </div>
        <div className={`dropdown ${this.props.className}`} style={{display: this.props.open ? 'block' : 'none'}}>
          <ul>
            {React.Children.map(this.props.children, (child, i) => {
              let display = 'none';
              if (this.state.expanded || this.props.noLimit || i < this.props.numVisible) {
                display = 'block';
              }
              return <li key={i} style={{display: display}}>{child}</li>;
            })}
          </ul>
          { !this.props.noLimit && !this.state.expanded &&
              this.props.children.length > this.props.numVisible &&
              <div className="button" onClick={() => this.setState({expanded: true})}>Show More</div> }
          </div>
      </div>
    );
  }
}

class Search extends Component {
  constructor(props) {
    super(props);
    let params = decodeQueryData();
    this.state = {
      filters: {
        funding: [],
        facility: [],
        discipline: [],
        housing: [],
        meal: [],
        program: [],
        accessibility: [],
        theme: [],
        language: []
      },
      selected: {
        funding: coerceArray(params.funding),
        facility: coerceArray(params.facility),
        discipline: coerceArray(params.discipline),
        housing: coerceArray(params.housing),
        meal: coerceArray(params.meal),
        program: coerceArray(params.program),
        accessibility: coerceArray(params.accessibility),
        theme: coerceArray(params.theme),
        language: coerceArray(params.language)
      },
      query: params.query || '',
      locations: params.locations || '',
      startDate: params.starts_at ? moment(params.starts_at) : null,
      endDate: params.ends_at ? moment(params.ends_at) : null,
      activeDropdown: null,
      showFilters: window.innerWidth >= FILTER_BREAKPOINT
    };

    window.addEventListener('resize', () => {
      if (window.innerWidth > FILTER_BREAKPOINT) {
        this.setState({showFilters: true});
      }
    });
  }

  componentDidMount() {
    API.get('/calls/filters', {}, (data) => {
      this.setState({filters: data});
    });
  }

  updateTagFilter(key) {
    return (props, on) => {
      let state = this.state;
      let selected = state.selected[key];
      let id = props.id;
      if (on && !selected.includes(id)) {
        selected.push(id);
      } else if (!on && selected.includes(id)) {
        selected.splice(selected.indexOf(id), 1);
      }
      this.setState(state);
    };
  }

  updateLanguage(selected) {
    let state = this.state;
    state.selected.language = selected.split(',');
    this.setState(state);
  }

  executeSearch() {
    let start = this.state.startDate ? this.state.startDate.toISOString() : '';
    let end = this.state.endDate ? this.state.endDate.toISOString() : '';
    let data = {
      query: this.state.query,
      locations: this.state.locations,
      starts_at: start,
      ends_at: end,
      ...this.state.selected
    };
    let params = encodeQueryData(data);
    window.location.href = `?${params}`;
  }

  setActiveDropdown(id) {
    if (this.state.activeDropdown === id) {
      this.setState({activeDropdown: null});
    } else {
      this.setState({activeDropdown: id});
    }
  }

  closeActiveDropdown() {
    this.setState({activeDropdown: null});
  }

  render() {
    let numSelectedMoreFilters =
      this.state.selected.housing.length +
      this.state.selected.meal.length +
      this.state.selected.program.length +
      this.state.selected.accessibility.length +
      this.state.selected.theme.length +
      this.state.selected.language.length +
      (this.state.startDate != null);

    return (
      <div>
        <div className='relative'>
          <input type='text' placeholder='Search'
            value={this.state.query}
            onChange={(ev) => this.setState({query: ev.target.value})}
            onKeyPress={(ev) => ev.key === 'Enter' && this.executeSearch()}/>
          <div className='button nested-button inverted' onClick={this.executeSearch.bind(this)}><span className='icon-search'></span></div>
        </div>
        <div id="search-filters-toggle" onClick={() => this.setState({showFilters: !this.state.showFilters})}>Search Filters</div>
        <div className="search-filters flex" style={{display: this.state.showFilters ? 'flex': 'none'}}>
          <Dropdown
            open={this.state.activeDropdown == 'funding'}
            onClick={() => this.setActiveDropdown('funding')}
            text='Funding' numSelected={this.state.selected.funding.length}>
            {this.state.filters.funding.map((d, i) => {
              return <ToggleButton key={i} id={d.id} text={d.text}
                on={this.state.selected.funding.includes(d.id)}
                onClick={this.updateTagFilter('funding')} />
            })}
          </Dropdown>
          <Dropdown
            open={this.state.activeDropdown == 'locations'}
            onClick={() => this.setActiveDropdown('locations')}
            text='Locations' numSelected={this.state.locations.split(',').filter(v => v).length}>
            <input type='text' value={this.state.locations} className='search-location' placeholder='Locations (comma-separated)' onChange={(ev) => this.setState({locations: ev.target.value})} onKeyUp={(ev) => ev.keyCode == 13 && this.closeActiveDropdown()} />
          </Dropdown>
          <Dropdown
            open={this.state.activeDropdown == 'facilities'}
            onClick={() => this.setActiveDropdown('facilities')}
            text='Facilities' numSelected={this.state.selected.facility.length}>
            {this.state.filters.facility.map((d, i) => {
              return <ToggleButton key={i} id={d.id} text={d.text}
                on={this.state.selected.facility.includes(d.id)}
                onClick={this.updateTagFilter('facility')} />
            })}
          </Dropdown>
          <Dropdown
            open={this.state.activeDropdown == 'disciplines'}
            onClick={() => this.setActiveDropdown('disciplines')}
            text='Disciplines' numSelected={this.state.selected.discipline.length}>
            {this.state.filters.discipline.map((d, i) => {
              return <ToggleButton key={i} id={d.id} text={d.text}
                on={this.state.selected.discipline.includes(d.id)}
                onClick={this.updateTagFilter('discipline')} />
            })}
          </Dropdown>
          <Dropdown
            open={this.state.activeDropdown == 'more_filters'}
            onClick={() => this.setActiveDropdown('more_filters')}
            text='More Filters' noLimit={true} className='search-filters-extra absolute-right' numSelected={numSelectedMoreFilters}>
            <div>
              <h1>Dates</h1>
              <DateRangePicker
                startDate={this.state.startDate}
                startDateId="start_date_id"
                endDate={this.state.endDate}
                endDateId="end_date_id"
                onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                noBorder={true}
                hideKeyboardShortcutsPanel={true}
                horizontalMargin={100}
              />
            </div>
            <InlineExpandable text='Housing'>
              {this.state.filters.housing.map((d, i) => {
                return <ToggleButton key={i} id={d.id} text={d.text}
                  on={this.state.selected.housing.includes(d.id)}
                  onClick={this.updateTagFilter('housing')} />
              })}
            </InlineExpandable>
            <InlineExpandable text='Meals'>
              {this.state.filters.meal.map((d, i) => {
                return <ToggleButton key={i} id={d.id} text={d.text}
                  on={this.state.selected.meal.includes(d.id)}
                  onClick={this.updateTagFilter('meal')} />
              })}
            </InlineExpandable>
            <InlineExpandable text='Public Programs'>
              {this.state.filters.program.map((d, i) => {
                return <ToggleButton key={i} id={d.id} text={d.text}
                  on={this.state.selected.program.includes(d.id)}
                  onClick={this.updateTagFilter('program')} />
              })}
            </InlineExpandable>
            <InlineExpandable text='Accessibility'>
              {this.state.filters.accessibility.map((d, i) => {
                return <ToggleButton key={i} id={d.id} text={d.text}
                  on={this.state.selected.accessibility.includes(d.id)}
                  onClick={this.updateTagFilter('accessibility')} />
              })}
            </InlineExpandable>
            <InlineExpandable text='Themes'>
              {this.state.filters.theme.map((d, i) => {
                return <ToggleButton key={i} id={d.id} text={d.text}
                  on={this.state.selected.theme.includes(d.id)}
                  onClick={this.updateTagFilter('theme')} />
              })}
            </InlineExpandable>
            <div>
              <h1>Languages</h1>
              <Select
                value={this.state.selected.language.join(',')}
                onChange={this.updateLanguage.bind(this)}
                labelKey='text'
                valueKey='id'
                multi={true}
                simpleValue={true}
                options={this.state.filters.language}/>
            </div>
          </Dropdown>
        </div>
      </div>
    );
  }
}

class SimpleSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      filters: {
        funding: []
      },
      selected: {
        funding: [],
      }
    };
  }

  componentDidMount() {
    API.get('/calls/filters', {}, (data) => {
      this.setState({filters: data});
    });
  }

  executeSearch() {
    let data = {
      query: this.state.query,
      ...this.state.selected
    };
    let params = encodeQueryData(data);
    window.location.href = `/calls/?${params}`;
  }

  updateTagFilter(key) {
    return (props, on) => {
      let state = this.state;
      let selected = state.selected[key];
      let id = props.id;
      if (on && !selected.includes(id)) {
        selected.push(id);
      } else if (!on && selected.includes(id)) {
        selected.splice(selected.indexOf(id), 1);
      }
      this.setState(state);
    };
  }

  render() {
    return (
      <div>
        <div className='relative'>
          <input type='text' placeholder='Search'
            value={this.state.query}
            onChange={(ev) => this.setState({query: ev.target.value})}
            onKeyPress={(ev) => ev.key === 'Enter' && this.executeSearch()}/>
          <div className='button nested-button inverted' onClick={this.executeSearch.bind(this)}><span className='icon-search'></span></div>
        </div>
        <div className='flex search-filters'>
          {this.state.filters.funding.map((d, i) => {
            return <ToggleButton key={i} id={d.id} text={d.text}
              on={this.state.selected.funding.includes(d.id)}
              onClick={this.updateTagFilter('funding')} />
          })}
        </div>
      </div>
    );
  }
}

export {Search, SimpleSearch};



// WEBPACK FOOTER //
// ./res/front/static/js/search.js